import * as React from 'react';

import {
    ExceptionFacturante,
    ExceptionFacturanteApiObject,
} from '@europrocurement/l2d-domain/reducers/achats/slices/exceptionFacturante';
import { useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { getDataThunkType } from '@europrocurement/l2d-redux-utils';
import { AxiosPromise } from 'axios';
import { NamedAxiosPromise } from '@europrocurement/flexy-components/types/NamedAxiosPromise';
import LabeledAsyncSwitch from './LabeledAsyncSwitch';

/**
 * Manages the automatic reminder (relance active) toggle for an exception facturante
 *
 * Responsible for:
 * - Generating API request to toggle relanceAuto
 * - Handling switch state and validation
 * - Integrating with data refresh mechanism
 */
const AsyncSwitchExceptionFacturanteRelanceAuto: React.FunctionComponent<{
    exceptionFacturante: ExceptionFacturante;
    fetchData: getDataThunkType<ExceptionFacturanteApiObject>;
    disabled?: boolean;
}> = function ({ exceptionFacturante, fetchData, disabled }) {
    const xIdSociete = useSociete();
    const { exceptionFacturanteApi } = useAchatsService();
    /**
     * Generates API request to toggle relanceAuto for the exception facturante
     *
     * @returns {NamedAxiosPromise[]} Configured API request for toggling relanceAuto
     */
    const createToggleRequest = (): NamedAxiosPromise[] => {
        if (!exceptionFacturante.id) return [];

        return [
            {
                name: 'updateExceptionFacturanteRelanceAuto',
                promise: exceptionFacturanteApi.patchExceptionFacturanteItem({
                    id: exceptionFacturante.id.toString(),
                    xIdSociete: Number(xIdSociete),
                    patchExceptionFacturanteItemRequest: {
                        relanceAuto: !exceptionFacturante.relanceAuto,
                    },
                }) as AxiosPromise,
            },
        ];
    };

    return (
        <LabeledAsyncSwitch
            key={`${exceptionFacturante.id}-relanceAuto_${exceptionFacturante.relanceAuto}`}
            requestsOnToggle={createToggleRequest}
            fetchData={fetchData}
            defaultChecked={exceptionFacturante?.relanceAuto || undefined}
            disabled={disabled}
            validationModal
        />
    );
};

export default AsyncSwitchExceptionFacturanteRelanceAuto;
